// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Dimmer_dimmer__LCtQT","dark":"Dimmer_dark__FFh4o"};